export const getPlainText = (text: string) => {
  return text.replace(/<[^>]*>?/gm, '').replace(/[^a-zA-Z0-9]+/g, '');
};

export const getStrictPlainText = (text: string) => {
  return text.replace(/<[^>]*>?/gm, '').replace(/[^a-zA-Z0-9()/\\.,]+/g, '');
};
